<template>
    <div class="clearfix">
        <Form :labelWidth="100" :model="formData" ref="form">
            <FormItem v-if="type === 2" :label="$t('fbb.carrieraccount.logistics_carrier', { defaultValue: '物流商' })" prop="groupName" :rules="required">
                <Input v-model="formData.groupName" />
            </FormItem>
            <FormItem :label="$t('fbb.carrieraccount.carrieraccount', { defaultValue: '承运商' })" prop="carrierId" :rules="required">
                <Select v-model="formData.carrierId">
                    <Option v-for="item in carrierAllList" :key="item.value" :value="item.value">{{item.label}}</Option>
                </Select>
            </FormItem>
            <FormItem :label="$t('erp.channelbase.country', { defaultValue: '国家' })" prop="regionId" :rules="required">
                <Select v-model="formData.regionId">
                    <Option v-for="item in countryList" :key="item.value" :value="item.attach.id">{{item.label}}</Option>
                </Select>
            </FormItem>
        </Form>
        <div class="margin-15 pull-right">
            <Button class="margin-right-15" type="primary" @click="nextStep">{{$t('fbb.accountmanage.next_step', { defaultValue: '下一步' })}}</Button>
            <Button type="default" @click="cancel">{{$t('global.common.operation_cancel', { defaultValue: '取消' })}}</Button>
        </div>
        <Spin v-if="loading" fix></Spin>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import {
    HttpUpdateAccountGroup,
    HttpCarrierAllList
} from "@/service/carrieraccount.js";
export default {
    props: ['activeid', 'type'],
    data () {
        return {
            loading: false,
            formData: {},
            carrierAllList: [],
            countryList:[],
        }
    },
    created () {
        this.getAllCarrier();
        this.countryList=this.getCountryList
    },
    computed: {
        ...mapGetters("dictionary", [
            "getCarrierAllList",
            "getBillcusWareList",
            "getSysAllList",
            "getCountryList"
        ]),
        required () {
            return [
                {
                    required: true,
                    message: this.$t('global.common.fill_required', { defaultValue: '请填写必填项' })
                }
            ]
        }
    },
    methods: {
        async getAllCarrier () {
            await HttpCarrierAllList().then(res => {
                this.carrierAllList = res.data.map(item => {
                    return {
                        label: item.carrierCode,
                        value: item.id
                    }
                });
            }, err => {
                this.$VMessage.error(err.message);
            });
        },
        async nextStep () {
            let flag = true;
            await this.$refs.form.validate(valid => {
                flag = valid;
            });
            console.log(flag);
            if (!flag) return;
            this.loading = true;
            await HttpUpdateAccountGroup({
                groupName: this.formData.groupName,
                carrierId: this.formData.carrierId,
                regionId:this.formData.regionId
            }).then(res => {
                let id = res.data.id;
                this.$router.push({
                    name: 'CarrierAccountUpdate',
                    params: {
                        type: 'edit',
                    },
                    query: {
                        id: id
                    }
                });
            }, err => {
                this.$VMessage.error(err.message);
            }).finally(() => {
                this.loading = false;
            });
        },
        cancel () {
            this.$emit('on-close');
        }
    }
}
</script>

<style>

</style>
